"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOTAL_ELS = exports.TOTAL_SMALL_EL = exports.TOTAL_EL = exports.RECLAIM_COST_PER_MONTH_EL = exports.MONEY_SAVED_PER_MONTH_EL = exports.HOURS_SAVED_PER_MONTH_EL = exports.AVERAGE_SALARY_INPUT_EL = exports.TEAM_SIZE_INPUT_EL = void 0;
const getWidgetQs_1 = require("../../utils/getWidgetQs");
const { qsOrThrowFit } = (0, getWidgetQs_1.getWidgetQs)(".roi_calc_widget");
exports.TEAM_SIZE_INPUT_EL = qsOrThrowFit("#ROI__TeamSize");
exports.AVERAGE_SALARY_INPUT_EL = qsOrThrowFit("#ROI__AverageSalary");
exports.HOURS_SAVED_PER_MONTH_EL = qsOrThrowFit("#ROI__HoursSavedPerMonth");
exports.MONEY_SAVED_PER_MONTH_EL = qsOrThrowFit("#ROI__MoneySavedPerMonth");
exports.RECLAIM_COST_PER_MONTH_EL = qsOrThrowFit("#ROI__ReclaimCostPerMonth");
exports.TOTAL_EL = qsOrThrowFit("#ROI__Total");
exports.TOTAL_SMALL_EL = qsOrThrowFit("#ROI__TotalSmall");
exports.TOTAL_ELS = [exports.TOTAL_EL, exports.TOTAL_SMALL_EL];
